import { call, put } from 'redux-saga/effects';
import { Messages } from '../../../../codegen/Localize';
import { IExtractTaskInfo } from '../../../../ts/models/IExtractTaskInfo';
import { Set } from '../../../../ts/models/Set';
import { ChangeScheduleAction } from '../../../../ts/services/ChangeScheduleAction';
import { requestFailed } from '../../../actions/RequestFailedAction';
import { ChangeExtractRefreshScheduleAction } from '../../../actions/spaces/ChangeExtractRefreshScheduleAction';
import { requestSpaceContents } from '../../../actions/spaces/RequestSpaceContentsActions';
import { ServiceLocator } from '../../../ServiceLocator';

export function* handleChangeExtractRefreshScheduleAction(action: ChangeExtractRefreshScheduleAction) {
  try {
    yield call(executeChangeExtractRefreshScheduleAction, action.tasks);
    yield put(requestSpaceContents());
  } catch (e) {
    yield put(requestFailed(e, Messages.unexpectedError()));
  }
}

export function executeChangeExtractRefreshScheduleAction(items: IExtractTaskInfo[]) {
  const changeScheduleService = ServiceLocator.get<ChangeScheduleAction>('ChangeScheduleAction');
  const context = ServiceLocator.getAngularActionContext();
  return changeScheduleService.forExtractTasks(Set.fromIdItemArray(items), context);
}
